import DOMPurify from 'dompurify';

/**
 * Conservative allowlist for tenant-authored email/notification HTML (SEC-H13).
 * Event handlers are stripped by DOMPurify; script/iframe hosts are not allowed.
 */
const EMAIL_HTML_PROFILE: Parameters<typeof DOMPurify.sanitize>[1] = {
  ALLOWED_TAGS: [
    'a',
    'b',
    'blockquote',
    'br',
    'caption',
    'code',
    'col',
    'colgroup',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'hr',
    'i',
    'img',
    'li',
    'ol',
    'p',
    'pre',
    'span',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'u',
    'ul',
  ],
  ALLOWED_ATTR: [
    'href',
    'name',
    'target',
    'rel',
    'src',
    'alt',
    'title',
    'class',
    'width',
    'height',
    'colspan',
    'rowspan',
    'align',
    'valign',
    'bgcolor',
    'color',
    'border',
    'cellpadding',
    'cellspacing',
    'style',
  ],
  ALLOW_DATA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false,
  KEEP_CONTENT: true,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'link', 'meta', 'base', 'form', 'input', 'button'],
  FORBID_ATTR: ['srcdoc'],
};

/** Remove whole dangerous elements (tag + inner content), then leftover open/close tags. */
function stripDangerousElements(html: string): string {
  return html
    .replace(/<\s*script\b[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi, '')
    .replace(/<\s*(iframe|object|embed|form)\b[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/<\/?(?:script|iframe|object|embed|link|meta|base|form)\b[^>]*>/gi, '');
}

/**
 * Sanitizes tenant-authored HTML immediately before `dangerouslySetInnerHTML`.
 */
export function sanitizeHtmlBody(html: string | null | undefined): string {
  if (!html) {
    return '';
  }

  const withoutHosts = stripDangerousElements(html);
  return String(DOMPurify.sanitize(withoutHosts, EMAIL_HTML_PROFILE));
}
